// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bej_a bhu_qn bhu_qo bhu_ua bhu_cy bhu_ty bhu_gm bhu_ka"};